import React, { useState, useEffect, useContext } from "react";
import { MsalContext } from "src/components/Contexts/MsalContext"
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import AudioWave from "../CallInfo/AudioWave";
import { RecordingViewModel } from "../ViewModels/RecordingViewModel";
import { useSnackbar } from 'notistack'
import Typography from "@mui/material/Typography";

interface ISingleCallWavBar {
    agentView?: boolean;
    recording?: RecordingViewModel
}

export default function SingleCallWavBar(props: ISingleCallWavBar) {
    const [recordingBlob, setRecordingBlob] = useState<Blob | null>(null)
    const { msalFetch } = useContext(MsalContext);
    const { enqueueSnackbar } = useSnackbar();
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        if (props.recording) {
            if (props.recording.wavFile.includes("callfinder.resqcs.co.uk")) {
                fileStillProcessingMessage()
            }
            else {
                setIsLoading(true);
                msalFetch(`api/Info/GetRecordingBlob?switchCallId=${props.recording.switchCallID}`)
                    .then(response => response.blob())
                    .then(data => {
                        setRecordingBlob(data);
                        setIsLoading(false)
                    });
            }
        }
    }, [props.recording])

    const fileStillProcessingMessage = () => {
        enqueueSnackbar("Call recording is still processing, please return in 30 minutes", {
            anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'center',
            },
            variant: 'warning'
        });
    }

    return (
        <AppBar position="static" color="default" sx={{ boxShadow: 'none', paddingLeft: 0, paddingRight: 0 }}>
            <Toolbar
                disableGutters
                sx={{
                    p: 0,

                    minHeight: 0,
                    width: '100%',
                    '&.MuiToolbar-root': {
                        minHeight: 0,
                        padding: 0,
                    }
                }}>{
                !isLoading && props.recording && recordingBlob ?
                    <AudioWave
                        wav={props.recording!.wavFile}
                        isClient={false}
                        agentView={props.agentView}
                        recordingFile={recordingBlob!} />
                    :
                    <Typography>No Recording Found.</Typography>
            }
            </Toolbar >
        </AppBar>
    );
}